import { observer } from "mobx-react";
import { useEffect } from "react";

import Plate from "components/UI/Plate/Plate";

import AppStore from "AppStore";
import popupStore from "./PopupStore";

import "./Popup.scss";

export const Popup = observer(
  ({
    modalType,
    title,
    subtitle,
    children,
    header = false,
    backButton,
    onBack,
    onClick = () => {},
  }) => {
    const plateClassName = `popup__plate ${modalType}`;
    const isPayModal = modalType === "paymodal";
    
    const handleClose = () => {
      popupStore.close();
      popupStore.closeReportModal();

      // TODO: setTimeout -> onTransitionEnd
      setTimeout(() => {
        onClick();
        AppStore.resetAgreed();
        AppStore.clearUploadedFile();
      }, 300);
    };

    useEffect(() => {
      const handleKeyDown = (e) => {
        if (e.keyCode === 27 && !isPayModal) {
          handleClose();
        }
      };

      const handleClickOverlay = (e) => {
        if (isPayModal) return;
        
        if (e.target.classList.contains("popup")) {
          handleClose();
        }
      };

      window.addEventListener("keydown", handleKeyDown);
      
      if (!isPayModal) {
        document.addEventListener("click", handleClickOverlay);
      }
      
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
        document.removeEventListener("click", handleClickOverlay);
      };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalType, isPayModal]);

    const handlePopupClick = (e) => {
      if (isPayModal && e.target === e.currentTarget) {
        e.stopPropagation();
        return;
      }
      
      if (e.target === e.currentTarget) {
        handleClose();
      }
    };

    return (
      <div
        className={`popup ${
          isPayModal ? 'popup--paymodal' : ''} ${popupStore.isOpen && popupStore.modalType === modalType
            ? "popup_opened"
            : ""
        }`}
        onClick={handlePopupClick}
      >
        <Plate className={plateClassName}>
          {header ? (
            <div className="popup__header">
              {backButton && (
                <button
                  className="popup__button-back"
                  type="button"
                  aria-label="Вернуться назад"
                  onClick={onBack}
                />
              )}
              <p className="popup__header-title">{title}</p>
              {subtitle && <p className="popup__header-subtitle">{subtitle}</p>}
              <button
                className="popup__button-close"
                style={header ? { marginLeft: "0" } : ""}
                type="button"
                aria-label="Закрыть модальное окно"
                onClick={handleClose}
              />
            </div>
          ) : (
            <>
              <button
                className="popup__button-close"
                type="button"
                aria-label="Закрыть модальное окно"
                onClick={handleClose}
              />
              <div className="popup__header">
                <p className="popup__header-title">{title}</p>
                {subtitle && (
                  <p className="popup__header-subtitle">{subtitle}</p>
                )}
              </div>
            </>
          )}
          {children}
        </Plate>
      </div>
    );
  }
);
